import { getPropertiesByProjectLogic } from "./Properties.logic";
import { saveListPropertiesByProject, saveCountPropertiesByProject } from "../Infrastructure/Properties.store";
import store from "../../Redux/store";

export async function getPropertiesByProject(projectId, params = {}) {
  const { resources: properties, count } = await getPropertiesByProjectLogic(projectId, params);
  
  store.dispatch(saveListPropertiesByProject(properties));
  store.dispatch(saveCountPropertiesByProject(count));
}
